<template>
  <div id="app">
    <header>
      <nav class="navbar navbar-light bg-light justify-content-between">
        <router-link to="/" class="navbar-brand">Chronicle</router-link>

        <router-link v-if="$route.name === 'Milestone'" :to="`/milestones/edit/${$route.params.slug}`">Edit
        </router-link>
        <router-link v-if="$route.name === 'EditMilestone'" to="/">Cancel</router-link>
      </nav>
    </header>

    <main class="d-flex justify-content-center w-100">
      <router-view></router-view>
    </main>

    <footer>
      <nav class="navbar navbar-light bg-light">
        <ul class="nav d-flex justify-content-between w-100">
          <li class="nav-item">
            <router-link class="nav-link" to="/">
              <icon name="list-unordered"></icon>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/new">
              <icon name="plus"></icon>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/settings">
              <icon name="gear"></icon>
            </router-link>
          </li>
        </ul>
      </nav>
    </footer>
  </div>
</template>

<script>
  export default {
    name: 'app',
    mounted () {
      this.$store.commit('log', 'Application Mounted.')
    }
  }
</script>

<style type="text/scss">
  #app {
    display: grid;
    grid-template-rows: min-content auto min-content;
    grid-template-areas: "header" "main" "footer"
  }

  #app > header {
    grid-area: header;
  }

  #app > main {
    grid-area: main;
  }

  #app > footer {
    grid-area: footer;
  }
</style>
